var map = {
	".": "/iLc",
	"./": "/iLc",
	"./01_trade_info": "dF/+",
	"./01_trade_info.json": "dF/+",
	"./02_last_price": "GtO6",
	"./02_last_price.json": "GtO6",
	"./03_mark_price": "BwZb",
	"./03_mark_price.json": "BwZb",
	"./04_depth": "fcau",
	"./04_depth.json": "fcau",
	"./05_bookTicker": "KrjX",
	"./05_bookTicker.json": "KrjX",
	"./06_kline": "sLxw",
	"./06_kline.json": "sLxw",
	"./07_24hr_ticker": "ywsQ",
	"./07_24hr_ticker.json": "ywsQ",
	"./index": "/iLc",
	"./index.js": "/iLc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NZzt";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/websocket/market ^.*$
// module id = NZzt
// module chunks = 3